import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import config from '@adc/configment'
import { Provider } from 'react-redux'
import { datadogRum } from '@datadog/browser-rum'
import logger from '@adc/logger'
import analytics from '@adc/analytics'
import { ApplicationContextProvider } from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import configureStore from '../common/store'
import App from '../common/components/app'
import '@adc/ui-adc/lib/styles.css'

/*
 * Analytics is initialized here so GTM can get started sooner
 * The init call is kept in our usual app/analytics location
 * This call will check if each analytics script has already loaded
 */
analytics.init(window.CONFIGS)

const store = configureStore(window.INITIAL_STATE.shellState)
const featureFlags = window.INITIAL_STATE.shellState.featureFlags
const experiments = window.INITIAL_STATE.experiments
// TODO: This can go into the ApplicationShell in the toolkit once we have settled on the proper abstraction
// we feel is suitable
if (featureFlags['fe.resi.enable-datadog-rum-session-replay']) {
  logger.info('RUM session replay enabled')
  datadogRum.startSessionReplayRecording()
}

hydrate(
  <ApplicationContextProvider
    graphWebsocket={new blueprint.primitives.GraphWebsocket()}
    featureFlags={featureFlags}
    experiments={experiments}
  >
    <Provider store={store}>
      <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
        <App experiments={experiments} />
      </BrowserRouter>
    </Provider>
  </ApplicationContextProvider>,
  window.ROOT_DOM_MOUNT
)
